import { Component } from '@angular/core';
import { UpsellCardComponent } from '@components/upsell-card/upsell-card.component';
import { UpsellSlugs } from '@enums/upsell-slugs';

@Component({
  selector: 'app-biotin',
  templateUrl: './biotin.component.html',
  imports: [UpsellCardComponent],
})
export class BiotinComponent {
  public readonly slug: UpsellSlugs = UpsellSlugs.Biotin;
}
